module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAAwklEQVRIibXWMQ5CIQwGYA7i5ruYnsAbub7N0c3VO+joOfQ3REgUodCflqQDTeBLkxIaAGhjC+ACYKM9y0APfNZNCzLQE8DKgAy0T7mDFmShwIAzkBqchVSgBTQMWkFDoCXUBa0hEfSAmqAXVAVj4poSR2Moxyndf46b5auynUNlLwD3XJkX+AOV3WgJ/kElZgVWoRo2CzahFsaCIiRhWrAL9bBRMD9cERrBStD1p5ZAlxmkBrpOVyWohhgsBjcRA+ENd/L4tearaXwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/zdw.png
// module id = Z1Wk
// module chunks = 1